import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Card from "./_card";

const AlumniInterviews: FC = () => {
  return (
    <div className="alumni-interviews">
      <Container>
        <Col>
          <Row>
            <h2>
              <FormattedMessage id="page.nml.alumni_recruitment.interview.title" />
            </h2>
            <Card />
          </Row>
        </Col>
      </Container>
    </div>
  );
};
export default AlumniInterviews;
